import { render } from "./NoRoundsPage.vue?vue&type=template&id=3d74a6e4&scoped=true"
import script from "./NoRoundsPage.vue?vue&type=script&lang=js"
export * from "./NoRoundsPage.vue?vue&type=script&lang=js"

import "./NoRoundsPage.vue?vue&type=style&index=0&id=3d74a6e4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d74a6e4"]])

export default __exports__